/** SC-06 — the one message sent for the whole slide: the user's request, then each shape's text, numbered. */

import type { RephraseTarget } from "../types";

/** PowerPoint separates paragraphs with \r and soft breaks with \v; send them as plain lines. */
function asLines(text: string): string {
  return text.replace(/\r\n|[\r\v]/g, "\n").trim();
}

export function buildRephrasePrompt(request: string, targets: readonly RephraseTarget[]): string {
  const shapes = targets.map((t, i) => `[${i + 1}] ${asLines(t.original)}`).join("\n\n");
  // Rewrites go back into fixed-size boxes, so the model is told each shape's length (AIVA-9184).
  // Kept out of the numbered blocks, which must hold the shapes' text only.
  const limits = targets.map((t, i) => `shape ${i + 1}: ${asLines(t.original).length}`).join(", ");
  return (
    `Rephrase the text of each numbered shape below. User request: "${request.trim()}"\n` +
    `Reply with ONLY a JSON array, one object per shape: [{"index":1,"text":"…"}].\n` +
    `Each rewrite must fit its box: no more characters than the shape has now (${limits}).\n\n` +
    shapes
  );
}
